module.exports = __webpack_public_path__ + "img/horizontal_4_2_9005.de6fb3d0.png";